import { Directive, ElementRef, Input, OnChanges, OnInit, Renderer2 } from '@angular/core';
import { environment } from '../../../environments/environment';

@Directive({
  selector: 'img[avatar]',
  standalone: true
})
export class AvatarDirective implements OnInit, OnChanges {

  @Input('avatar') customAvatar?: string;
  @Input('avatarId') avatarId?: string;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit(): void {
    // Gera um número determinístico com base no ID se disponível, ou aleatório caso contrário
    const avatarNumber = this.getAvatarNumber();
    const fallback = `${environment.cdnUrl}/assets/images/avatars/${avatarNumber}.png`;

    if (this.customAvatar) {
      this.renderer.setAttribute(this.el.nativeElement, 'src', this.customAvatar);
      this.el.nativeElement.onerror = () => {
        this.renderer.setAttribute(this.el.nativeElement, 'src', fallback);
        this.el.nativeElement.onerror = null; // Remove o manipulador de erro para evitar loops infinitos
      };
    } else {
      this.renderer.setAttribute(this.el.nativeElement, 'src', fallback);
    }
  }

  ngOnChanges(): void {
    this.ngOnInit();
  }


  /**
   * Gera um número determinístico entre 1 e 100 com base no avatarId
   * Se avatarId não estiver definido, retorna um número aleatório
   */
  private getAvatarNumber(): number {
    if (!this.avatarId) {
      return Math.floor(Math.random() * 100) + 1;
    }
    
    // Soma os códigos ASCII de cada caractere no ID
    let sum = 0;
    for (let i = 0; i < this.avatarId.length; i++) {
      sum += this.avatarId.charCodeAt(i);
    }
    
    // Garante que o resultado esteja entre 1 e 100
    return (sum % 100) + 1;
  }
}
